import { css } from '@emotion/css';

import {
  Colors,
  FontSize,
  FontWeight,
  MEDIUM_DEVICE_MQ,
  SMALL_DEVICE_MQ,
  Spacing,
} from 'apps/shared/scripts/styles/constants';

export const headerClassName = css({
  background: Colors.White,
  padding: `${Spacing.LG}px ${Spacing.MD}px`,
  position: 'sticky',
  top: 0,
  left: 0,
  right: 0,
  width: '100%',

  [SMALL_DEVICE_MQ]: {
    padding: `${Spacing.LG}px ${Spacing.LG}px ${Spacing.MD + 4}px`,
  },
});

export const rowClassName = css({
  alignItems: 'center',
  display: 'flex',
});

export const headingClassName = css({
  color: Colors.Primary,
  fontSize: FontSize.LARGE + 4,
  fontWeight: FontWeight.BOLD,
});

export const preActionClassName = css({
  marginRight: Spacing.SM,
});

export const backButtonClassName = css({
  color: Colors.Primary,
  padding: 0,
  '&:hover': {
    color: Colors.PrimaryHover,
  },
});

export const actionClassName = css({
  marginLeft: 'auto',
});

export const dismissClassName = css({
  position: 'relative',
  top: 0,
  left: 0,
  zIndex: 999,
});

export const dismissButtonClassName = css({
  background: 'none',
  border: 'none',
  borderRadius: '50%',
  padding: 0,
  position: 'relative',
  i: {
    height: 20,
    marginRight: 0,
    width: 20,
    svg: {
      fill: Colors.Primary,
    },
  },
  '&:hover, &:active': {
    [MEDIUM_DEVICE_MQ]: {
      background: 'rgba(255, 255, 255, 0.2)',
      '&::before': {
        background: 'rgba(66, 79, 96, 0.05)',
      },
    },
  },
  '&::before': {
    content: '""',
    display: 'block',
    borderRadius: '50%',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(calc(-50% - 0.5px), calc(-50% - 0.5px))',
    height: 40,
    width: 40,
  },
});
